import React from 'react'
import bgImage from '../../assets/servicesImages/uiux/hero.png'
import uiux from '../../assets/servicesImages/uiux/uiux.png'
import uiux2 from '../../assets/servicesImages/uiux/uiux2.png'
import bottom from '../../assets/servicesImages/uiux/last.png'
import a from '../../assets/servicesImages/uiux/a.png'
import b from '../../assets/servicesImages/uiux/b.png'
import c from '../../assets/servicesImages/uiux/c.png'
import d from '../../assets/servicesImages/uiux/d.png'
import e from '../../assets/servicesImages/uiux/e.png'
import a2 from '../../assets/servicesImages/uiux/1.png'
import b2 from '../../assets/servicesImages/uiux/2.png'
import c2 from '../../assets/servicesImages/uiux/3.png'
import d2 from '../../assets/servicesImages/uiux/4.png'
import e2 from '../../assets/servicesImages/uiux/5.png'
import f2 from '../../assets/servicesImages/uiux/6.png'
import g2 from '../../assets/servicesImages/uiux/7.png'
import Slider from 'react-slick'

const items = [
    {
        image: a,
        title: 'UI/UX strategy & consulting',
        desc: 'Our design thinking expert consultants will get in touch with you to ideate, strategize and formulate the best possible design for your business goals and objectives.',
    },
    {
        image: b,
        title: 'SEO-friendly designs',
        desc: 'Performance testing determines the speed, responsiveness, and stability under different test case scenarios and workloads.',
    },
    {
        image: c,
        title: 'Sitemap & wireframing',
        desc: "We write test cases and conduct repetitive tests through exploratory testing to ensure user-focused application coverage.",
    },
    {
        image: d,
        title: 'Responsive design',
        desc: "Risk assessment and penetration testing to defend your application from malicious threats affecting functionality.",
    },
    {
        image: e,
        title: 'Cross-browser compatibility',
        desc: 'Optimized for consistency across all browsers and devices — mobile and desktop.',
    },
]

const items2 = [
    {
        image: a2,
        title: 'Comprehensive quality assessment',
        desc: 'UI/UX & websites tailored to customer behavior, enhancing engagement and conversions.',
    },
    {
        image: b2,
        title: 'Robust informational architecture',
        desc: 'Clear UI/UX with custom layouts, SEO-friendly content, and relevant headings.',
    },
    {
        image: c2,
        title: 'Collaborative research and consultation',
        desc: 'Cutting-edge UI/UX designs with transparent collaboration for tech-business success.',
    },
    {
        image: d2,
        title: 'Secure & scalable applications',
        desc: 'Web apps built with security and scalability to adapt to growing customer needs.',
    },
    {
        image: e2,
        title: 'Customized competitive designs',
        desc: 'Market analysis to deliver trendy, high-performing web designs.',
    },
    {
        image: f2,
        title: 'Responsive & fluid designs',
        desc: 'Device-independent responsive designs to boost engagement and reach.',
    },
    {
        image: g2,
        title: 'On-Demand website update',
        desc: 'Timely updates to keep your website modern and competitive.',
    },
]

const sliderSettings = {
    className: "center",
    centerMode: true,
    infinite: true,
    slidesToShow: 3,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 3000, // large screens default
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 1024, // md to lg
            settings: {
                slidesToShow: 2.5,
                centerMode: false,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerMode: false,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                centerMode: false,
            }
        }
    ]
    
}

const Card = ({ image, title, desc }) => (
    <div className='p-4 h-full'>
        <div className='bg-white shadow-md rounded-xl overflow-hidden hover:shadow-lg transition duration-300 transform hover:scale-105 h-full flex flex-col justify-between'>
            <img src={image} alt='card' className='w-full h-48 object-cover' />
            <div className='p-4 flex flex-col justify-between flex-1'>
                <h3 className='text-lg font-semibold text-center mb-2'>{title}</h3>
                <p className='text-sm text-gray-700 text-justify flex-1'>{desc}</p>
            </div>
        </div>
    </div>
)


const UIUX = () => {
    return (
        <div className='flex flex-col gap-20'>
            {/* Hero Section */}
            <div className='h-[40vh] md:h-[50vh] lg:h-screen w-full text-white flex justify-start items-center pt-24 relative bg-cover bg-center'
                style={{ backgroundImage: `url(${bgImage})` }}>
                <div className="absolute inset-0 bg-[rgba(0,0,0,0.45)] z-0"></div>
                <div className='z-10 px-6 sm:px-10 md:px-16 max-w-xl'>
  <h1 className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6'>
    UI/UX Design
  </h1>
  <p className='text-base sm:text-lg md:text-xl lg:text-2xl'>
    Create a customer-centric, interactive, and elegant UI/UX design with Nextwebi for higher business engagement.
  </p>
</div>

            </div>

            {/* Intro Section */}
            <section className='px-10 md:px-20 flex flex-col lg:flex-row gap-10 items-center'>
            <div className='text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed sm:leading-7 flex-1 space-y-4 sm:space-y-6'>
  <p>
    At Esparse Matrix Solutions, we create hyper-personalized, responsive web designs with interactive UIs to enhance user experiences and boost customer conversion.
  </p>
  <p>
    We focus on understanding your business goals through thorough analysis and pre-development surveys to deliver a results-driven website.
  </p>
</div>

                <img src={uiux} alt='uiux' className='w-full max-w-lg rounded-xl shadow-md' />
            </section>

            {/* Why UI/UX Design */}
            <section className='px-10 md:px-20'>
            <h2 className='text-center text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold mb-6 sm:mb-8'>
  Why customised UI/UX design service
</h2>
    <Slider {...sliderSettings}>
        {items.map((item, i) => (
            <div key={i} className="h-[420px] flex items-stretch">
                <Card {...item} />
            </div>
        ))}
    </Slider>
</section>

            {/* Key Differentiator */}
            <section className='px-10 md:px-28 space-y-10'>
            <h2 className='text-center text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold mb-6 sm:mb-8'>
            Key differentiator</h2>
            <p className='text-sm sm:text-base md:text-lg lg:text-xl text-justify leading-relaxed sm:leading-7'>
  Esparse Matrix Solutions is a leading web designing company that creates responsive, high-performing websites that boost branding and user experience. Some of our key features:
</p>

                <Slider {...sliderSettings}>
                {items2.map((item, i) => (
  <div key={i} className="h-[420px] flex items-stretch">
    <Card {...item} />
  </div>
))}

                </Slider>
            </section>

            {/* Design Process */}
            <section className='px-4 md:px-8 flex flex-col lg:flex-row items-start gap-6'>
    <div className='flex-1 space-y-4 text-sm '>
        <div className='transition-all duration-300 hover:scale-105'>
            <h4 className='font-semibold text-xl text-[#2D3748] hover:text-[#6A60F0] mb-1 ml-12'>1. Information gathering & analysis</h4>
            <p className='ml-12 pt-1 text-[#4A5568] mb-3'>Collecting detailed client data to align the design with business objectives.</p>
        </div>
        <div className='transition-all duration-300 hover:scale-105'>
            <h4 className='font-semibold text-xl text-[#2D3748] hover:text-[#6A60F0] mb-1 ml-12'>2. Wireframing</h4>
            <p className='ml-12 pt-1 text-[#4A5568] mb-3'>Sitemaps and wireframes communicate the UI/UX structure and navigation flow.</p>
        </div>
        <div className='transition-all duration-300 hover:scale-105'>
            <h4 className='font-semibold text-xl text-[#2D3748] hover:text-[#6A60F0] mb-1 ml-12'>3. UI/UX & Website Designing</h4>
            <p className='ml-12 pt-1 text-[#4A5568] mb-3'>Design using latest tools with unique and engaging graphics.</p>
        </div>
        <div className='transition-all duration-300 hover:scale-105'>
            <h4 className='font-semibold text-xl text-[#2D3748] hover:text-[#6A60F0] mb-1 ml-12'>4. Usability testing & hosting</h4>
            <p className='ml-12 pt-1 text-[#4A5568] mb-3'>Testing for real-world scenarios and going live to drive conversions.</p>
        </div>
    </div>
    <img
  src={uiux2}
  alt='uiux'
  className='w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out transform hover:scale-105 mt-6 lg:mt-3 lg:mr-20 mx-auto lg:mx-0'
/>
</section>




            {/* Final Section */}
            <div className='flex flex-col gap-10 px-6 md:px-16 lg:px-28 mb-16'>
  <p className='text-center font-nunito text-2xl md:text-3xl font-semibold leading-tight'>
    Unique UI/UX design service features
  </p>

  <p className='text-base md:text-lg leading-7 text-justify text-[#4A5568] max-w-3xl mx-auto'>
    Accelerate your business growth with compelling website designs and visually attractive UI/UX features. As one of the leading web design companies in Bangalore, India, we analyze, strategize, and create customized website designs tailored to help you attract and retain customers, establishing a strong online brand identity.
  </p>

  <img
    src={bottom}
    alt='bottom'
    className='w-full max-w-4xl mx-auto mt-4 rounded-xl shadow-md'
  />
</div>

        </div>
    )
}

export default UIUX
